import { Moon, Sun } from 'lucide-react';
import useColorMode from '../../hooks/useColorMode';

export default function ThemeToggle({ className = '' }: { className?: string }) {
  const [mode, setMode] = useColorMode();
  const dark = mode === 'dark';
  return (
    <button type="button" onClick={() => setMode(dark ? 'light' : 'dark')}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`grid h-11 w-11 place-items-center rounded-[12px] border border-line-strong bg-surface p-0 text-ink hover:bg-surface-2 ${className}`}>
      {dark ? <Sun size={18} strokeWidth={1.8} /> : <Moon size={18} strokeWidth={1.8} />}
    </button>
  );
}
